<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" title="选择商品" :width="800" :index="0" @hide="hide"
		@submit="submit" moduleName="goods" code="goods" :store="store" selectType="checkbox" @boxdataload="boxdataload" />
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			table: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					buttons:[],
					columns: [{
						field: 'goodscode',
						title: '商品编码',	
						render:"$input",
						span:8,
						props:{
							importsearch:true
						}
					},{
						field: 'goodsname',
						title: '商品名称',	
						render:""
					},{
						field: 'goodsmodel',
						title: '规格',
						render:""
					},{
						field: 'price',
						title: '单价',
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 100,
						enabled: true,
						pageSizes: [100],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]			
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			show(){
				this.store.table = this.table
				// if (this.box.getTable()) {
				// 	this.box.getTable().commitProxy('query')
				// }
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				
				return new Promise((resolve, reject) => {
					// console.log(page, form, other,reject)
					// let data = []
					// resolve({list:data})
					this.$api.exchangeorder.queryGoodsAndSpec({
						mode: 'box',
						index: this.index,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>